<template>
<div id="story">
  <Vue100vh v-if="!isMobile().any">
    <div class="w-100 h-100 bg-cover" v-prlx.background="{ speed: 0.07 }" :style="{backgroundImage: 'url('+ bgImage +')'}">
    </div>
  </Vue100vh>
  <div v-else class="w-100 bg-cover bg-center bg-mobile-header" v-prlx.mobile.background="{ speed: 0.07 }" :style="{backgroundImage: 'url('+ bgImage +')'}">
  </div>

  <div class="py-3">
  </div>
  
  <b-container class="py-5" id="story-2">
    <div class="d-flex justify-content-center v-scroll-reveal">
      <div class="border-top border-bottom border-dark border-2px py-3">
        <h3 class="overpass text-center h1">STORY</h3>
        <h6 class="h4 text-center d-none d-md-block">〜左ききのシャツ with 10YC ができるまで〜</h6>
        <h6 class="h4 text-center px-4 line-height-1_8 d-md-none mb-0">左ききのシャツ with 10YC<br>ができるまで</h6>
      </div>
    </div>

    <div class="py-3">
    </div>

    <b-row class="mt-5">
      <b-col cols="12" md="6" lg="5" class="mb-3">
        <img class="img-fluid scroll-reveal-up" src="@/assets/images/story-1.jpg" srcset="@/assets/images/story-1@2x.jpg 2x">
      </b-col>
      <b-col cols="12" md="6" lg="7" class="d-flex align-items-center">
        <p class="line-height-2 pl-lg-5 scroll-reveal-up text-justify">
          左ききのシャツ開発のきっかけとなったのは、2019年夏の終わり。とあるご縁から、10YCさんとイベントをすることになり、その最初の打ち合わせのことでした。「左利き用のシャツって……作れるんですか？」と店長が切り出したのです。左利き用のシャツ？ 聞いたことがないシャツですが、そこに居合わせた10YCの左利きメンバーが前のめりで言いました。「できます！ 僕もないのが不思議でした。やりましょう」。こうして、思わぬスピード感で左ききのシャツの開発がスタートしたのです。
        </p>
      </b-col>
    </b-row>

    <h4 class="text-center mt-5 h3">
      <span class="dotline scroll-reveal-up">
        ユーザーだからこその絶大な信頼感
      </span>
    </h4>
    <b-row class="mt-5">
      <b-col cols="12" sm="6" lg="5" order-sm="2" class="mb-3">
        <img class="img-fluid scroll-reveal-up" src="@/assets/images/story-2.jpg" srcset="@/assets/images/story-2@2x.jpg 2x">
      </b-col>
      <b-col cols="12" sm="6" lg="7" order-sm="1" class="d-flex align-items-center">
        <p class="line-height-2 pr-lg-5 scroll-reveal-up text-justify">
          <img style="width: 70px;" class="mx-auto d-block ml-md-5" src="@/assets/images/typo-left-handed.svg">
          <br>
          ベースにしたのは、10YCでも定番の１着「10YC Shirts」。選定には迷いがありませんでした。何しろ、代表の加藤がすでに愛用していた品だから。さらりとした手触り、スッキリしたシルエット、速乾・ノーアイロンの機能性。何度も着て、体験したからこその信頼感がありました。これを左利き用として「合わせを左前」、「ポケットを右側」に変更。胸ポケットには「Left-handed」のワンポイント刺繍を入れました。間違いないベースがあるからこそ、自信を持ってお届けできるシャツになったのです。
        </p>
      </b-col>
    </b-row>

    <h4 class="text-center mt-5 h3">
      <span class="dotline scroll-reveal-up">
        10YCと左ききの道具店
      </span>
    </h4>
    <b-row class="mt-5">
      <b-col cols="12" sm="6" lg="5" class="mb-3">
        <img class="img-fluid scroll-reveal-up" src="@/assets/images/story-3.jpg" srcset="@/assets/images/story-3@2x.jpg 2x">
      </b-col>
      <b-col cols="12" sm="6" lg="7" class="d-flex align-items-center">
        <p class="line-height-2 pl-lg-5 scroll-reveal-up text-justify">
          一見、何の接点もないように見えた2つのブランドですが、その後の交流の中でいくつも共通点が見つかりました。「瞬間的に消費されるものではなく、長く使われるものを扱う」こと。売り煽るような「セールをしない」こと。「自分たちが使いたいと思うものだけを作る」こと。取り組んでいくスタンスの近さも相まって、左ききのシャツは展開を広げます。ネイビーを加えた2色展開、刺繍なしバージョンの開発などを行いつつ、今では左ききの道具店にとって掛け替えのない商品になりました。
        </p>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col cols="12" sm="6" lg="5" order-sm="2" class="mb-3">
        <img class="img-fluid scroll-reveal-up" src="@/assets/images/story-4.jpg" srcset="@/assets/images/story-4@2x.jpg 2x">
      </b-col>
      <b-col cols="12" sm="6" lg="7" order-sm="1" class="d-flex align-items-center">
        <div class="pr-lg-5">
          <h4 class="text-center h3 scroll-reveal-up">
            <span class="dotline">
              <img style="width: 90px;" src="@/assets/images/10yc.svg"><span class="align-middle ml-2">について</span>
            </span>
          </h4>
          <p class="line-height-2 pr-lg-5 mt-4 text-justify scroll-reveal-up">
            10YCは、着る人も作る人も豊かになることを目指して、作り手の顔、工場の現場、製造にかかる原価、といったこれまで一般消費者には見えてこなかった、服の背景にも光を当てた服づくりを行っています。“見ること”が変われば、着ることは変わっていく。それを体現することで、ブランド名「10 Years Clothing」にもある「10年後も着続けたい」と思える商品生産を実践しています。
          </p>
          <p class="text-right pr-lg-5">
            <a class="text-dark" href="https://10yc.jp/" target="_blank">https://10yc.jp/</a>
          </p>
        </div>
      </b-col>
    </b-row>

  </b-container>
</div>
</template>

<script>
import bg from '@/assets/images/bg-3.jpg'
import bg2x from '@/assets/images/bg-3@2x.jpg'
import bgXs from '@/assets/images/bg-3@xs.jpg'
import isMobile from 'ismobilejs'
import Vue100vh from 'vue-div-100vh'

export default {
  name: 'Story',
  components: {
    Vue100vh
  },
  data() {
    return {
      isMobile: isMobile
    }
  },
  computed: {
    bgImage() {
      if(isMobile().phone) {
        return bgXs
      } else if (window.innerWidth > 1440) {
        return bg2x
      } else if (window.devicePixelRatio > 1) {
        return bg2x
      } else {
        return bg
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dotline {
  background-image: url('~@/assets/images/dot-line.png');
  padding: 20px 10px;
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;
}
.bg-mobile-header {
  height: 260px;
  @media screen and (min-width: 768px) {
    height: 400px;
  }
}
</style>
